import { collapseErrorMessage, errorCodeList, errorKeyMap, HttpDefaultErrorHandle, resolveHttpErrorMessage } from '@/common/error/error-code'
import { team } from '@/common/basis/root-injector'
import { router } from '@/router'
import { toLoginPage } from '@/services/login.service'

export const HttpErrorHandles: HttpDefaultErrorHandle[] = [{
  errorCode: [errorKeyMap.AUTH_EXPIRED.ret, errorKeyMap.NEED_LOGIN.ret],
  handler () {
    toLoginPage(true)
  }
}, {
  errorCode: [errorKeyMap.NOT_TEAM_ADMIN.ret],
  handler () {
    team.updateCurrentTeam(null)
    router.replace('/team')
  }
}, {
  errorCode: [errorKeyMap.PERMISSION_PRICE_NOT_FOUND.ret, errorKeyMap.CAL_PRICE_NOT_FOUND.ret],
  handler () {
    router.replace('/dashboard/service-subscribe')
  }
}, {
  errorCode: errorCodeList,
  handler (ret, msg) {
    const r = typeof ret === 'number' ? ret : Number(ret)
    const resolved = Number.isFinite(r) ? resolveHttpErrorMessage(r, msg) : ''
    msg = resolved || msg
    collapseErrorMessage(msg)
  }
}]
